import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import './App.css'
import './styles/scrollAnimations.css'
import InstallPrompt from './InstallPrompt';
import Home from './Home';
import SignIn from './Auth/SignIn/SignIn';
import SignUp from './Auth/SignUp/SignUp';
import Foundation from './Sections/Foundation/Foundation';
import FoundationCourseOverview from './Sections/Foundation/FoundationCourseOverview';
import FellowshipLocator from './Sections/FellowshipLocator/FellowshipLocator';
import AboutUsPg from './AboutusPage/AboutusPg';
import LoveworldSingers from './Sections/LoveworldSingers/LoveworldSingers';
import YouthChurch from './Sections/YouthChurch/YouthChurch';
import ChildrensChurch from './Sections/ChildrensChurch/ChildrensChurch';
import SocialServices from './Sections/SocialServices/SocialServices';
import PastServices from './Sections/PastServices/PastServices';






import ForgotPassword from './Auth/ForgotPassword/ForgotPassword';
import ResetPassword from './Auth/ForgotPassword/ResetPassword';
import KingsChatSuccess from './Auth/KingsChatSuccess';
import AdminLogin from './Admin/AdminLogin';
import AdminDashboard from './Admin/AdminDashboard';
import AdminLive from './Admin/AdminLive';
import Footer from './Sections/Footer/Footer';

import AuthHandler from './Auth/AuthHandler';

function App() {
  return (
    <Router>
      <InstallPrompt />
      <AuthHandler />
      <div className="App">
        <main className="main-content">
          <Routes>
            <Route path="/" element={<Home />} />        {/* Home route */}
            <Route path="/foundation" element={<Foundation />} /> {/* Foundation route */}
            <Route path="/foundation-course" element={<FoundationCourseOverview />} /> {/* Foundation  Course page */}
            <Route path="/fellowships" element={<FellowshipLocator />} /> {/* Fellowships locator page */}
            <Route path="/signIn" element={<SignIn />} /> {/* SignIn page */}
            <Route path="/signup" element={<SignUp />} /> {/* SignIn page */}
            <Route path="/kingschat-success" element={<KingsChatSuccess />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/about" element={<AboutUsPg />} /> {/* About route */}
            <Route path="/loveworld-singers" element={<LoveworldSingers />} />
            <Route path="/youth-church" element={<YouthChurch />} />
            <Route path="/childrens-church" element={<ChildrensChurch />} />
            <Route path="/social-services" element={<SocialServices />} />
            <Route path="/past-services" element={<PastServices />} />
            {/* Admin Routes */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
            <Route path="/admin/live" element={<AdminLive />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
